import { CIMSSelectProps, LabeledValueType } from '../types'

export type ToLabeledValues<Record, Records = Record[]> = {
  /**
   * @see {@link toLabeledValues}
   */
  toLabeledValue: (
    record: Record | undefined | null
  ) => LabeledValueType | undefined
  /**
   * a callback to help set the initial form value for
   * {@link CIMSSelectProps.simple|non-simple} selects
   */
  toLabeledValues: (records: Records | undefined | null) => LabeledValueType[]
}

export type FromLabeledValues<Value, Values = Value[]> = {
  /**
   * @see {@link fromLabeledValues}
   */
  fromLabeledValue: (
    labeledValue: LabeledValueType | undefined | null
  ) => Value | undefined
  /**
   * a callback to help transform {@link labeledValues} returned from a form
   * into simple values for a mutation
   */
  fromLabeledValues: (
    labeledValues: LabeledValueType[] | undefined | null
  ) => Values
}

/**
 * @see {@link ToLabeledValues}
 * @see {@link FromLabeledValues}
 */
export type CommonSelectContextOptions = Pick<
  CIMSSelectProps,
  'options' | 'loading'
>

export type CommonSelect<
  OmitAdditional extends keyof CIMSSelectProps =
    | 'loading'
    | 'options'
    | 'simple',
  PickAdditional extends keyof CIMSSelectProps = never
> = Omit<CIMSSelectProps, OmitAdditional | 'loading' | 'options' | 'simple'> &
  Pick<CIMSSelectProps, PickAdditional>

/**
 * a separator used to join and split composite select options
 */
export const SEPARATOR = `~~~` as const
